/* CRID — panier plein écran (tiroir). Ouverture instantanée depuis le cache /cart.js préchargé,
   rafraîchissement réseau en arrière-plan. PC 2 colonnes / mobile empilé, zéro emoji.
   Dates de livraison : jours ouvrés (lundi-vendredi), selon la politique d'expédition —
   préparation 24-48 h ouvrées (+5 jours ouvrés si le panier contient une personnalisation),
   puis standard 10-16, express Europe-Asie 6-9, États-Unis 2-3 jours ouvrés après expédition. */
(function(){
  var root = document.getElementById('lysCartDrawer');
  if(!root) return;
  var CFG; try{ CFG = JSON.parse(document.getElementById('lysCartCfg').textContent); }catch(e){ CFG = {t:{},ship:{x:{}},shipFree:{},zeroDec:[]}; }
  var T = CFG.t || {};
  var S = CFG.ship || {}; var SX = S.x || {};
  var bodyEl = document.getElementById('lyscdBody');
  var CART = null, busy = false, shipOpen = false;

  /* ---------- utils ---------- */
  function rootUrl(){ var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||CFG.root||'/'; if(r.charAt(r.length-1)!=='/') r+='/'; return r; }
  function lang(){ return document.documentElement.lang || undefined; }
  function isOptLine(it){ return /^crid-option-/.test(it.handle||''); }
  function cur(){ return (CART&&CART.currency) || CFG.shopCurrency || 'EUR'; }
  function dec(){ return (CFG.zeroDec||[]).indexOf(cur())>=0 ? 0 : 2; }
  function money(cents){
    // Shopify renvoie toutes les devises en centièmes (JPY inclus) ; zeroDec ne joue que sur l'affichage.
    var d=dec(), v=cents/100;
    try{ return new Intl.NumberFormat(lang(),{style:'currency',currency:cur(),minimumFractionDigits:d,maximumFractionDigits:d}).format(v); }
    catch(e){ return v.toFixed(d)+' '+cur(); }
  }
  function esc(s){ return (s==null?'':String(s)).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function thumb(u,w){ if(!u) return ''; return u + (u.indexOf('?')>=0?'&':'?') + 'width='+(w||200); }
  function freeThr(){ var f=CFG.shipFree||{}; var v=f[cur()]; if(v==null) v=f[CFG.shopCurrency]; if(v==null) v=200; return v*100; } // seuil -> centièmes

  /* ---------- jours ouvrés ---------- */
  function day0(){ var n=new Date(); var d=new Date(n.getFullYear(),n.getMonth(),n.getDate()); while(d.getDay()===0||d.getDay()===6) d.setDate(d.getDate()+1); return d; }
  function addBD(d,n){ d=new Date(d.getFullYear(),d.getMonth(),d.getDate()); while(n>0){ d.setDate(d.getDate()+1); var w=d.getDay(); if(w!==0&&w!==6) n--; } return d; }
  function iso(d){ return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
  function fmtDate(d){ try{ return new Intl.DateTimeFormat(lang(),{day:'numeric',month:'long'}).format(d); }catch(e){ return d.getDate()+'/'+(d.getMonth()+1); } }
  function dateTag(d){ return '<b data-iso="'+iso(d)+'">'+esc(fmtDate(d))+'</b>'; }
  function range(txt,a,b){ return esc(txt||'').replace('{a}',dateTag(a)).replace('{b}',dateTag(b)); }
  /* personnalisation : une ligne d'option CRID (flocage, écusson…) ou une création CRID brodée */
  function isCustom(){ if(!CART) return false; for(var i=0;i<CART.items.length;i++){ var it=CART.items[i]; if(isOptLine(it) || it.vendor==='CRID') return true; } return false; }
  function expressPrice(){
    // 7,99 € (politique) converti au taux du marché exposé par Shopify, celui du paiement.
    var dev=(window.Shopify&&Shopify.currency)||{}; var code=dev.active||cur(); var rate=parseFloat(dev.rate||'1')||1; var v=7.99*rate;
    try{ return new Intl.NumberFormat(lang(),{style:'currency',currency:code}).format(v); }catch(e){ return v.toFixed(2)+' '+code; }
  }
  function shipRow(t,d){ return '<div class="lyscd-shp__r">'+(t?'<p class="lyscd-shp__t">'+t+'</p>':'')+'<div class="lyscd-shp__d">'+d+'</div></div>'; }
  function shipHtml(){
    var c=isCustom(), p=c?5:0, s=day0();
    var sMin=addBD(s,1+p), sMax=addBD(s,2+p);
    var expT=esc(S.exp_t)+' — '+esc(expressPrice())+(SX.exp_free?' · '+esc(SX.exp_free).replace('{amt}',esc(money(freeThr()))):'');
    return '<div class="lyscd-shp" data-custom="'+(c?1:0)+'">'
      + shipRow(esc(S.std_t), range(SX.std_d, addBD(sMin,10), addBD(sMax,16)))
      + shipRow(expT, range(SX.exp_eu, addBD(sMin,6), addBD(sMax,9))+'<br>'+range(SX.exp_us, addBD(sMin,2), addBD(sMax,3)))
      + '<p class="lyscd-shp__n">'+esc(SX.note)+'</p>'
      + shipRow(esc(S.prep_t), esc(SX.prep)+(c?'<br><b>'+esc(SX.custom)+'</b>':''))
      + shipRow(esc(S.ret_t), esc(SX.ret))
      + shipRow('', S.help_html||'')
      + '</div>';
  }

  /* ---------- cart fetch ---------- */
  function getCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }
  function refresh(){ return getCart().then(function(c){ CART=c; if(root.classList.contains('open')) render(); updateBubble(); }).catch(function(){}); }

  function updateBubble(){
    if(!CART) return;
    var supp=0; CART.items.forEach(function(it){ if(isOptLine(it)) supp+=it.quantity; });
    var vis=CART.item_count-supp;
    var b=document.getElementById('rinaCartCount');
    if(b){ b.textContent=vis; b.classList.toggle('hidden', vis<=0); }
  }

  function change(body){ return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json();}); }

  /* ---------- item ops ---------- */
  function setBusy(b){ busy=b; root.classList.toggle('lyscd--busy', b); }
  function setQty(key,qty){
    if(busy) return; setBusy(true);
    change({id:key,quantity:Math.max(0,qty)})
      .then(getCart).then(function(c){ CART=c; render(); updateBubble(); })
      .catch(function(){}).then(function(){ setBusy(false); });
  }

  /* ---------- render ---------- */
  function render(){
    if(!CART){ bodyEl.innerHTML=''; return; }
    var supp=0; CART.items.forEach(function(it){ if(isOptLine(it)) supp+=it.quantity; });
    var vis=CART.item_count-supp;
    if(vis<=0){
      bodyEl.innerHTML='<div class="lyscd-empty lyscd-anim"><p class="lyscd-empty__t">'+esc(T.empty_title)+'</p><p class="lyscd-empty__x">'+esc(T.empty_text)+'</p><a class="lyscd__co lyscd__co--sm" href="'+esc(rootUrl()+'collections/maillots')+'">'+esc(T.empty_cta)+'</a></div>';
      return;
    }
    var th=freeThr(), total=CART.total_price;
    /* — palier livraison express offerte (droite PC / haut mobile) — */
    var perks='<div class="lyscd-bl lyscd-bl--perks lyscd-anim"><div class="lyscd-perk">';
    if(total>=th) perks+='<div class="lyscd-perk__row is-ok">'+ico('truck')+'<span>'+esc(T.ship_ok)+'</span></div>';
    else perks+='<div class="lyscd-perk__row">'+ico('truck')+'<span>'+esc(T.ship_need).replace('%amt%',money(th-total))+'</span></div>';
    perks+='<div class="lyscd-bar"><i style="width:'+Math.min(100,total/th*100).toFixed(1)+'%"></i></div>';
    perks+='<div class="lyscd-perk__sep"></div></div></div>';
    /* — articles (gauche) — */
    var items='<div class="lyscd-bl lyscd-bl--items lyscd-anim"><div class="lyscd-items">';
    CART.items.forEach(function(it){
      var vt = it.variant_title && it.variant_title!=='Default Title' ? esc(it.variant_title) : '';
      var mx=Math.max(10,it.quantity), opts='';
      for(var q=1;q<=mx;q++) opts+='<option value="'+q+'"'+(q===it.quantity?' selected':'')+'>'+q+'</option>';
      items+='<div class="lyscd-it" data-key="'+esc(it.key)+'">'
        + '<a class="lyscd-it__img" href="'+esc(it.url)+'"><img src="'+esc(thumb(it.image,200))+'" alt="'+esc(it.product_title)+'" loading="lazy"></a>'
        + '<div class="lyscd-it__main">'
          + '<a class="lyscd-it__t" href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'
          + (vt?'<div class="lyscd-it__v">'+vt+'</div>':'')
          + '<div class="lyscd-it__row">'
            + '<label class="lyscd-qsel"><span>'+esc(T.qty)+'</span><select data-act="qsel">'+opts+'</select>'+ico('chev')+'</label>'
            + '<span class="lyscd-it__p">'+money(it.final_line_price)+'</span>'
          + '</div>'
          + '<div class="lyscd-it__links"><a class="lyscd-it__lk" href="'+esc(it.url)+'">'+esc(T.modify)+'</a><button class="lyscd-it__lk" data-act="rm" type="button">'+esc(T.remove)+'</button></div>'
        + '</div></div>';
    });
    items+='</div></div>';
    /* — totaux + livraison (gauche) — */
    var sum='<div class="lyscd-bl lyscd-bl--sum lyscd-anim"><div class="lyscd-sum">'
      + '<div class="lyscd-sum__r"><span class="lyscd-sum__mut">'+esc(T.subtotal)+'</span><span>'+money(total)+'</span></div>'
      + '<div class="lyscd-sum__r"><div class="lyscd-sum__ship"><span>'+esc(T.shipping)+'</span>'
        + '<button class="lyscd-sum__shipinfo'+(shipOpen?' is-open':'')+'" data-act="shipinfo" type="button">'+esc(T.ship_info)+' '+ico('arr')+'</button></div>'
        + '<span class="lyscd-sum__mut">--</span></div>'
      + '<div class="lyscd-sum__r lyscd-sum__tot"><span>'+esc(T.total)+'</span><span>'+money(total)+'</span></div>'
      + '</div><div class="lyscd-shipx'+(shipOpen?' is-open':'')+'" id="lyscdShipx">'+shipHtml()+'</div></div>';
    /* — paiement + CTA — */
    var co='<div class="lyscd-checkout"><span class="lyscd-pay__h">'+esc(T.pay_title)+'</span><div class="lyscd-pay__ic">'+payIcons()+'</div>'
      + '<div class="lyscd-secure">'+ico('lock')+'<div><b>'+esc(T.secure_title)+'</b><span>'+esc(T.secure_text)+'</span></div></div>'
      + '<a class="lyscd__co" href="'+esc(rootUrl()+'checkout')+'" id="lyscdCheckout">'+esc(T.checkout)+'</a>'
      + '<button class="lyscd__cont" data-close type="button">'+esc(T.continue)+'</button></div>';
    bodyEl.innerHTML='<div class="lyscd-grid"><div class="lyscd-colL">'+items+sum+'</div><div class="lyscd-colR">'+perks+'</div></div>'+co;
  }

  /* ---------- icônes (SVG uniquement — aucun emoji) ---------- */
  function ico(n){
    if(n==='truck') return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M1 4h13v11H1zM14 8h4l3 3v4h-7z"/><circle cx="6" cy="18" r="1.8"/><circle cx="18" cy="18" r="1.8"/></svg>';
    if(n==='lock') return '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.3"><rect x="4" y="10" width="16" height="11" rx="1.5"/><path d="M8 10V7a4 4 0 018 0v3"/></svg>';
    if(n==='chev') return '<svg viewBox="0 0 12 12" width="9" height="9" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M2.5 4.5L6 8l3.5-3.5"/></svg>';
    if(n==='arr') return '<svg viewBox="0 0 12 12" width="8" height="8" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M4.5 2.5L8 6l-3.5 3.5"/></svg>';
    return '';
  }
  function payIcons(){
    var vs='<span class="lyscd-pi" title="Visa"><svg viewBox="0 0 40 24"><rect width="40" height="24" rx="3"/><text x="20" y="16" text-anchor="middle" font-family="Arial" font-weight="700" font-size="10" fill="#fff">VISA</text></svg></span>';
    var mc='<span class="lyscd-pi" title="Mastercard"><svg viewBox="0 0 40 24"><rect width="40" height="24" rx="3"/><circle cx="16" cy="12" r="6.5" fill="#fff" opacity=".9"/><circle cx="24" cy="12" r="6.5" fill="#fff" opacity=".55"/></svg></span>';
    var ax='<span class="lyscd-pi" title="American Express"><svg viewBox="0 0 40 24"><rect width="40" height="24" rx="3"/><text x="20" y="15" text-anchor="middle" font-family="Arial" font-weight="700" font-size="7" fill="#fff">AMEX</text></svg></span>';
    var pp='<span class="lyscd-pi" title="PayPal"><svg viewBox="0 0 40 24"><rect width="40" height="24" rx="3"/><text x="20" y="16" text-anchor="middle" font-family="Arial" font-style="italic" font-weight="700" font-size="9" fill="#fff">PayPal</text></svg></span>';
    var ap='<span class="lyscd-pi" title="Apple Pay"><svg viewBox="0 0 40 24"><rect width="40" height="24" rx="3"/><g fill="#fff"><path d="M12.6 8.2c.4-.5.7-1.2.6-1.9-.6 0-1.3.4-1.7.9-.4.4-.7 1.1-.6 1.8.7.1 1.3-.3 1.7-.8zm.6.9c-1 0-1.8.6-2.3.6-.5 0-1.2-.6-2-.6-1 0-2 .6-2.5 1.5-1.1 1.9-.3 4.7.7 6.2.5.8 1.1 1.6 1.9 1.6.8 0 1-.5 2-.5s1.2.5 2 .5 1.3-.8 1.8-1.5c.6-.9.8-1.7.8-1.8 0 0-1.6-.6-1.6-2.4 0-1.5 1.2-2.2 1.3-2.3-.7-1-1.8-1.2-2.1-1.3z"/><text x="24" y="16" text-anchor="middle" font-family="Arial" font-weight="600" font-size="9">Pay</text></g></svg></span>';
    return vs+mc+ax+pp+ap;
  }

  /* ---------- open / close (instantané, façon nav) ---------- */
  var armTimer=null;
  function open(){
    if(root.classList.contains('open')) return;
    root.classList.add('lyscd--armed');
    root.classList.add('open'); root.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('lyscd-lock');
    if(CART) render();
    clearTimeout(armTimer); armTimer=setTimeout(function(){ root.classList.remove('lyscd--armed'); },950);
    refresh();
  }
  function close(){ root.classList.remove('open'); root.setAttribute('aria-hidden','true'); document.documentElement.classList.remove('lyscd-lock'); }
  window.lysOpenCart=function(e){ if(e){ e.preventDefault(); } open(); return false; };
  window.lysCloseCart=close;

  /* ---------- events ---------- */
  root.addEventListener('click',function(e){
    var c=e.target.closest('[data-close]'); if(c){ close(); return; }
    var si=e.target.closest('[data-act="shipinfo"]');
    if(si){
      shipOpen=!shipOpen;
      si.classList.toggle('is-open', shipOpen);
      var x=document.getElementById('lyscdShipx');
      if(x){ if(shipOpen) x.innerHTML=shipHtml(); x.classList.toggle('is-open', shipOpen); }
      return;
    }
    var it=e.target.closest('.lyscd-it'); if(!it) return;
    var key=it.getAttribute('data-key');
    if(e.target.closest('[data-act="rm"]')) setQty(key,0);
  });
  root.addEventListener('change',function(e){
    var s=e.target.closest('select[data-act="qsel"]'); if(!s) return;
    var it=e.target.closest('.lyscd-it'); if(!it) return;
    setQty(it.getAttribute('data-key'), parseInt(s.value,10)||1);
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&root.classList.contains('open')) close(); });

  // intercepte tout lien vers /cart (icône de l'en-tête, etc.)
  document.addEventListener('click',function(e){
    var a=e.target.closest('a[href]'); if(!a) return;
    if(a.hasAttribute('data-no-drawer')) return;
    var href=a.getAttribute('href')||'';
    if(/\/cart\/?($|\?)/.test(href) && !/\/cart\/(add|change|update|clear)/.test(href)){ e.preventDefault(); open(); }
  });

  // après un ajout ou une modification du panier : met à jour la bulle (on reste sur la page).
  var _f=window.fetch;
  window.fetch=function(){
    var url = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
    var p=_f.apply(this,arguments);
    if(typeof url==='string'){
      if(/\/cart\/add(\.js)?/.test(url)) p.then(function(r){ if(r&&r.ok){ setTimeout(function(){ getCart().then(function(c){ CART=c; updateBubble(); }).catch(function(){}); },40); } }).catch(function(){});
      else if(/\/cart\/(change|update|clear)(\.js)?/.test(url)) p.then(function(r){ if(r&&r.ok){ setTimeout(function(){ getCart().then(function(c){ CART=c; updateBubble(); if(root.classList.contains('open')) render(); }).catch(function(){}); },40); } }).catch(function(){});
    }
    return p;
  };

  // préchargement : cache prêt AVANT le premier clic → ouverture instantanée
  getCart().then(function(c){ CART=c; updateBubble(); }).catch(function(){});
  window.addEventListener('pageshow',function(e){ if(e.persisted) refresh(); });
})();
